import '../css/app.css';

import Alpine from 'alpinejs';

import nav from './components/nav.js';
import './consent-cookie-cleanup.js';
import './components/reveal.js';
import './components/submit-burst.js';

// Alpine: small interactions written in the markup with x-data. The navigation (menu
// and About dropdown) is the "nav" component in components/nav.js.
Alpine.data('nav', nav);

window.Alpine = Alpine;
Alpine.start();

// Swiper is only fetched on pages that contain a slider, rather than being bundled
// into every page load. Add data-slider="<name>" to the Swiper container; the names
// are in components/slider.js.
if (document.querySelector('[data-slider]')) {
    import('./components/slider.js');
}
